import { apiEmpleo } from "../../util/ApiEmpleo";
import { TGetContractsItem } from "./contract.types";

const apiGetContractOffer = async (contractId: string) => {
  const res: TGetContractsItem = await apiEmpleo.get(`offers/${contractId}`);

  return res;
};

export { apiGetContractOffer };
